import {
  Component,
  AfterContentInit,
  ContentChildren,
  QueryList
} from '@angular/core';

import {
  SkyToolbarSectionComponent
} from './toolbar-section.component';


export class SkyToolbarComponent implements AfterContentInit {

  public hasSections: boolean = false;

  
  private sectionComponents: QueryList<SkyToolbarSectionComponent>;

  public ngAfterContentInit() {
    this.hasSections = this.sectionComponents.length > 0;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-toolbar',
  styles: [`.sky-toolbar-container {
  min-height: 49px;
  background-color: #ffffff;
  padding: 5px 10px;
  border-top: 1px solid #cdcfd2;
  border-bottom: 1px solid #cdcfd2;
  display: flex;
  align-items: center;
  position: relative;
}

.sky-toolbar-container /deep/ sky-toolbar-section:not(:first-child) .sky-toolbar-section {
  border-top: 1px solid #cdcfd2;
}

.sky-toolbar-sectioned {
  display: block;
  padding: 0;
}
`],
  template: `<div
  class="sky-toolbar-container"
  [ngClass]="{ 'sky-toolbar-sectioned': hasSections}">
  <ng-content></ng-content>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'sectionComponents': [{ type: ContentChildren, args: [SkyToolbarSectionComponent, {descendants: true}, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
